<script>
import iCompetition from './_competition.js';

export default {
  name: 'match-entity',

  mixins: [iCompetition],

  data() {
    return {
      display_name: null,
      score: null,
      isWinner: false,
      round_type: null,
    }
  },

  props: [
    'rounds',
    'results',
    'match',
    'entity',
    'isEntityA',
    'isHome',
    'applications',
    'delegated_progression',
    'competition_type'
  ],

  template: `
    <div class="match-entity" :id="entity.key" v-bind:class="{ 'is-winner': isWinner}">
      <div class="entity-name">
        <div v-if="isHome && competition_type != 'round robin'" class="is-home">
            <i class="fa fa-home" aria-hidden="true"></i>
            <span class="screen-reader-text">Home Team</span>
        </div>
        {{ display_name }}
      </div>
      <div class="entity-score">{{ score }}</div>
    </div>
  `,

  mounted() {
    this.display_name = this.entityDisplayName(this.entity, this.results, this.rounds, this.applications, this.delegated_progression);
    this.score = this.entityScore(this.match, this.isEntityA);
    this.isWinner = this.entityWinner(this.entity, this.match);
  }
}
</script>
